import styled from '@emotion/styled';

export const ConfigurationRowStyled = styled.div`
  margin-top: 24px;
`;
